import { createSlice } from '@reduxjs/toolkit';
import { getOnSaleCount, getOrderCountByMonth, getOrderCountByPreviousMonth, getSales, getSoldCount, getVehicleCountByMonth } from './dashboardService';

const initialState = {
    vehicleQuantity: {
        iSaleQuantityLoading: null,
        isQuantitySuccess: null,
        quantity: [],
    },
    sales: {
        isSalesLoading: null,
        isSalesSuccess: null,
        sales: [],
    },
    onSaleVehicleCount: {
        isCountLoading: null,
        isCountSuccess: null,
        count: 0,
    },
    soldVehicleCount: {
        isSoldCountLoading: null,
        isSoldCountSuccess: null,
        soldCount: 0,
    },
    orderCount: {
        isOrderLoading: null,
        isOrderSuccess: null,
        orderCount: 0,
    },
    previousMonthOrderCount: {
        isPreviousOrderLoading: null,
        isPreviousOrderSuccess: null,
        previousMonthOrderCount: 0,
    },
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getVehicleCountByMonth.pending, (state) => {
            state.vehicleQuantity = {
                ...initialState.vehicleQuantity,
                isQuantityLoading: true,
            };
        });

        builder.addCase(getVehicleCountByMonth.rejected, (state) => {
            state.vehicleQuantity = {
                ...initialState.vehicleQuantity,
                isQuantityLoading: false,
                isQuantitySuccess: false,
            };
        });

        builder.addCase(getVehicleCountByMonth.fulfilled, (state, action) => {
            state.vehicleQuantity = {
                ...initialState.vehicleQuantity,
                isQuantityLoading: false,
                isQuantitySuccess: true,
                quantity: action.payload,
            };
        });

        // Sale payment
        builder.addCase(getSales.pending, (state) => {
            state.sales = {
                ...initialState.sales,
                isSalesLoading: true,
            };
        });

        builder.addCase(getSales.rejected, (state) => {
            state.sales = {
                ...initialState.sales,
                isSalesLoading: false,
                isSalesSuccess: false,
            };
        });

        builder.addCase(getSales.fulfilled, (state, action) => {
            state.sales = {
                ...initialState.sales,
                isSalesLoading: false,
                isSalesSuccess: true,
                sales: action.payload,
            };
        });

        // On Sale count
        builder.addCase(getOnSaleCount.pending, (state) => {
            state.onSaleVehicleCount = {
                ...initialState.onSaleVehicleCount,
                isCountLoading: true,
            };
        });

        builder.addCase(getOnSaleCount.rejected, (state) => {
            state.onSaleVehicleCount = {
                ...initialState.onSaleVehicleCount,
                isCountLoading: false,
                isCountSuccess: false,
            };
        });

        builder.addCase(getOnSaleCount.fulfilled, (state, action) => {
            state.onSaleVehicleCount = {
                ...initialState.onSaleVehicleCount,
                isCountLoading: false,
                isCountSuccess: true,
                count: action.payload.count,
            };
        });

        // Sold count
        builder.addCase(getSoldCount.pending, (state) => {
            state.soldVehicleCount = {
                ...initialState.soldVehicleCount,
                isSoldCountLoading: true,
            };
        });

        builder.addCase(getSoldCount.rejected, (state) => {
            state.soldVehicleCount = {
                ...initialState.soldVehicleCount,
                isSoldCountLoading: false,
                isSoldCountSuccess: false,
            };
        });

        builder.addCase(getSoldCount.fulfilled, (state, action) => {
            state.soldVehicleCount = {
                ...initialState.soldVehicleCount,
                isSoldCountLoading: false,
                isSoldCountSuccess: true,
                soldCount: action.payload.count,
            };
        });

        // Order count
        builder.addCase(getOrderCountByMonth.pending, (state) => {
            state.orderCount = {
                ...initialState.orderCount,
                isOrderLoading: true,
            };
        });

        builder.addCase(getOrderCountByMonth.rejected, (state) => {
            state.orderCount = {
                ...initialState.orderCount,
                isOrderLoading: false,
                isOrderSuccess: false,
            };
        });

        builder.addCase(getOrderCountByMonth.fulfilled, (state, action) => {
            state.orderCount = {
                ...initialState.orderCount,
                isOrderLoading: false,
                isOrderSuccess: true,
                orderCount: action.payload.count,
            };
        });

        // Previous Month Order count
        builder.addCase(getOrderCountByPreviousMonth.pending, (state) => {
            state.previousMonthOrderCount = {
                ...initialState.previousMonthOrderCount,
                isPreviousOrderLoading: true,
            };
        });

        builder.addCase(getOrderCountByPreviousMonth.rejected, (state) => {
            state.previousMonthOrderCount = {
                ...initialState.previousMonthOrderCount,
                isPreviousOrderLoading: false,
                isPreviousOrderSuccess: false,
            };
        });

        builder.addCase(getOrderCountByPreviousMonth.fulfilled, (state, action) => {
            state.previousMonthOrderCount = {
                ...initialState.previousMonthOrderCount,
                isPreviousOrderLoading: false,
                isPreviousOrderSuccess: true,
                previousMonthOrderCount: action.payload.count,
            };
        });
    },
});

export default dashboardSlice.reducer;
